import { getIndexBetween, getIndices, ZERO_INDEX_KEY, type IndexKey } from '../../../../../libs/platform/whiteboard/src/canvas/reordering'

export type RankedCard = { id: string; rank: IndexKey }

export function compareCards(a: RankedCard, b: RankedCard): number {
  return a.rank < b.rank ? -1 : a.rank > b.rank ? 1 : a.id < b.id ? -1 : a.id > b.id ? 1 : 0
}

export function cardRank(json: unknown): IndexKey {
  const content = (json as { content?: { kanbanRank?: string } } | null)?.content
  return (content?.kanbanRank ?? ZERO_INDEX_KEY) as IndexKey
}

/** Equal keys occur for unranked cards and concurrent inserts. Reindex that
 * destination column on explicit reorder, preserving its exact requested order.
 * Reads never write ranks. Ordinary drags write only the moved page.
 */
export function planCardOrder(cards: readonly RankedCard[], id: string, beforeId?: string): RankedCard[] {
  const destination = cards.filter(card => card.id !== id).toSorted(compareCards)
  const before = beforeId ? destination.findIndex(card => card.id === beforeId) : destination.length
  if (before < 0) throw new Error('Card destination no longer exists')
  const lower = destination[before - 1]?.rank
  const upper = destination[before]?.rank
  if (lower && upper && lower === upper) {
    const ordered = [...destination.slice(0, before), { id, rank: ZERO_INDEX_KEY }, ...destination.slice(before)]
    const ranks = getIndices(ordered.length)
    return ordered.map((card, index) => ({ id: card.id, rank: ranks[index] }))
  }
  return [{ id, rank: getIndexBetween(lower, upper) }]
}
